import React from 'react'
import Head from 'next/head'
import Router from 'next/router'
import {
  StyledError,
  StyledHeader,
  StyledSection,
  StyledButton,
  StyledTitle,
  StyledContainer,
  StyledLogo,
} from '@/components/styles'
import Icon from '@/assets/icons'

class Error extends React.Component {
  static getInitialProps({ res, statusCode }) {
    res && res.status(statusCode)

    return { statusCode }
  }

  render() {
    const { statusCode } = this.props

    const is500page = +statusCode !== 404

    const title404 = 'Page not found'
    const title500 = 'Internal Server Error'

    return (
      <>
        <Head>
          <title>{is500page ? title500 : title404}</title>
        </Head>
        <StyledError view={statusCode}>
          {is500page && (
            <StyledHeader>
              <StyledHeader.Inner>
                <StyledHeader.Container>
                  <StyledHeader.Logo>
                    <StyledLogo href="/">
                      <img src="/images/logo.jpeg" alt="Sante" height={54} width={237}/>
                    </StyledLogo>
                  </StyledHeader.Logo>
                </StyledHeader.Container>
              </StyledHeader.Inner>
            </StyledHeader>
          )}

          <StyledContainer>
            <StyledSection pt="large" pb="large">
              <StyledTitle size="x-large" mb="small">
                {is500page ? title500 : title404}
              </StyledTitle>
              {is500page ? (
                <>
                  <StyledError.Text>
                    Please try reloading the page a little later or{' '}
                    <a href="/">return to the home page</a>.
                  </StyledError.Text>

                  <StyledError.Btn>
                    <StyledButton
                      onClick={() => {
                        Router.reload()
                      }}
                    >
                      Reload
                    </StyledButton>
                  </StyledError.Btn>
                </>
              ) : (
                <>
                  <StyledError.Text>
                    The page may have been removed or there is an error in the page address. Try
                    using <a href="/search">search</a> or return to the home page.
                  </StyledError.Text>

                  <StyledError.Btn>
                    <StyledButton as="a" href="/">
                      Home
                    </StyledButton>
                  </StyledError.Btn>
                </>
              )}
            </StyledSection>
          </StyledContainer>
        </StyledError>
      </>
    )
  }
}

export default Error
